import { Component, h, Prop, Host } from '@stencil/core';

@Component({
  tag: 'lilu-fix-product-tile',
  styleUrl: 'lilu-fix-product-tile.scss',
  shadow: true,
})
export class LiluFixProductTile {
  @Prop() type = '';
  @Prop() buttontext = '';
  @Prop() buttonlink = '';
  @Prop() target = '_self';
  @Prop() heading = '';
  @Prop() headercolor = '';
  @Prop() buttontype = '';

  render() {
    if (this.type === 'mobile') {
      return (
        <Host>
          <a class="fix-product-tile mobile" href={`${this.buttonlink}`} target={this.target}>
            <slot name="image"></slot>
            <div class="text">{`${this.heading}`}</div>
            <div class="button">
              <lilu-button
                slot="button"
                type={this.buttontype === 'Black' ? 'primary' : 'secondary'}
                appearance={this.buttontype === 'Black' ? '' : 'outline'}
                height="h-sm"
                width="w-full-width"
                font="semibold"
                fontsize="size-12 lg-size-14"
                transform="uppercase"
              >
                {`${this.buttontext}`}
              </lilu-button>
            </div>
          </a>
        </Host>
      );
    } else {
      return (
        <Host>
          <a class="fix-product-tile desktop" href={`${this.buttonlink}`} target={this.target}>
            <div class="backdrop"></div>
            <slot name="image"></slot>
            <div class={`text ${this.headercolor}`}>{`${this.heading}`}</div>
            <lilu-button
              slot="button"
              type={this.buttontype === 'Black' ? 'primary' : 'secondary'}
              appearance={this.buttontype === 'Black' ? '' : 'outline'}
              height="h-lg"
              width="w-full-width"
              font="semibold"
              fontsize="size-18 lg-size-20"
              transform="uppercase"
            >
              {`${this.buttontext}`}
            </lilu-button>
          </a>
        </Host>
      );
    }
  }
}
